import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYardiLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 27,
	height: 27,
	viewBox: "0 0 27 27",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_45316_112676)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M5.63818 24.5239V15.1072L21.9937 1.74707V11.4242L5.63818 24.5239Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M8.60228 12.5008L5.63818 10.839V1.74707L8.60228 3.47482V12.5008Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_45316_112676",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 26.0465,
			height: 26.0465,
			fill: "white"
		})
	}) })]
});
export default SvgYardiLogo;
